import { DatePipe } from "@angular/common";
import { HttpParams } from "@angular/common/http";

const datePipe = new DatePipe('fr');

export const buildHttpParams = (filters: Record<string, any>): HttpParams => {
    let params = new HttpParams();
    for (const key in filters) {
        if (filters[key] || filters[key] === 0) {
            if (Array.isArray(filters[key])) {
                for (const item of filters[key]) params = params.append(key, item.toString());
            } else if (typeof filters[key].getMonth === 'function') {
                params = params.append(key, datePipe.transform(filters[key], 'yyyy-MM-dd')!);
            } else {
                params = params.append(key, filters[key].toString());
            }
        }
    }
    return params;
}

export const toFixedNumber = ({ num, digits }: { num: number, digits: number }): number => {
	const pow = Math.pow(10, digits);
	return Math.round(num * pow) / pow;
}

export enum OperationName {
	"RECEIPT" = "Réception",
	"TRASH" = "Casse",
	"SUPPLIER-SCRAP" = "Casse fournisseur",
	"DONATION" = "Donation",
	"GIFT" = "Cadeaux",
	"CONSUMPTION" = "Conso. cuisine",
	"TASTING" = "Dégustation",
	"INVENTORY" = "Inventaire",
	"SALE" = "Vente magasin",
	"DELIVERY" = "Transfert",
	"KITCHEN-PRODUCTION" = "Production cuisine",
	"LABO-CONSUMPTION" = "Conso. Labo",
	"CONSUMABLE" = "Consommable"
}